var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Flex, IconButton, Input, MenuButton, MenuItem, MenuList, Menu, useMenuButton, Box, } from "@chakra-ui/react";
import React from "react";
import { FiMinus, FiPlus } from "react-icons/fi";
const fontSizePickerClassName = "fontSizePicker";
const MenuInputButton = React.forwardRef(({ onClose, fontSize, setFontSize }, ref) => {
    const _a = useMenuButton(), { role } = _a, rest = __rest(_a, ["role"]);
    return (React.createElement(Box, { role: role, ref: ref, className: fontSizePickerClassName },
        React.createElement(Input, Object.assign({ borderRadius: 0, size: "sm", textAlign: "center", value: fontSize, onChange: (event) => {
                const newFontSize = isNaN(parseInt(event.currentTarget.value))
                    ? 0
                    : parseInt(event.currentTarget.value);
                setFontSize(newFontSize);
            } }, rest, { onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === "Escape") {
                    onClose();
                }
            }, onClick: (e) => {
                e.currentTarget.focus();
                rest.onClick(e);
            } }))));
});
const fontSizes = [
    6, 8, 10, 12, 14, 16, 18, 21, 24, 28, 32, 36, 42, 48, 56, 64, 72, 80, 88, 96,
    104, 120, 144,
];
export const FontSizePicker = ({ onChange, defaultFontSize, onOpen, }) => {
    const [fontSize, setFontSize] = React.useState(defaultFontSize !== null && defaultFontSize !== void 0 ? defaultFontSize : 16);
    React.useEffect(() => {
        onChange(fontSize);
    }, [fontSize]);
    return (React.createElement(Flex, { width: "130px", position: "relative", className: fontSizePickerClassName },
        React.createElement(IconButton, { borderRadius: 0, "aria-label": "R\u00E9duire la taille de la police d'\u00E9criture", icon: React.createElement(FiMinus, null), height: "2rem", width: "2rem", onMouseDown: (e) => {
                e.preventDefault();
                setFontSize((fontSize) => (fontSize === 0 ? 0 : fontSize - 1));
            } }),
        React.createElement(Menu, { autoSelect: false, onOpen: onOpen }, ({ onClose }) => {
            return (React.createElement(React.Fragment, null,
                React.createElement(MenuButton, { as: MenuInputButton, onClose: onClose, setFontSize: setFontSize, fontSize: fontSize }),
                React.createElement(MenuList, { maxHeight: "40vh", overflow: "auto" }, fontSizes.map((size, index) => {
                    return (React.createElement(MenuItem, { key: `font-size-item-${index}`, onClick: () => {
                            setFontSize(size);
                        } }, size));
                }))));
        }),
        React.createElement(IconButton, { borderRadius: 0, "aria-label": "Augmenter la taille de la police d'\u00E9criture", icon: React.createElement(FiPlus, null), height: "2rem", width: "2rem", onMouseDown: (e) => {
                e.preventDefault();
                setFontSize((fontSize) => fontSize + 1);
            } })));
};
